
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class PelletsHerstellung extends Vue {
  head() {
    return {
      ...generateMetaTags(this.$route.path, "pellets-herstellung"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Der komplette Produktionsprozess",
        title: "Springen Sie zum Bereich: Vier Hauptphasen",
        href: { hash: "#anker-phasen" },
      },
      {
        name: "Was wird für die Pelletherstellung verwendet",
        title: "Springen Sie zum Bereich: Rohstoffe",
        href: { hash: "#anker-rohstoffe" },
      },
      {
        name: "Wo werden Pellets hergestellt?",
        title: "Springen Sie zum Bereich: Standorte & Struktur",
        href: { hash: "#anker-standorte" },
      },
      {
        name: "Wie werden Pellets hergestellt mit garantierter Qualität?",
        title: "Springen Sie zum Bereich: Qualitätssicherung",
        href: { hash: "#anker-qualitaet" },
      },
      {
        name: "Rohstoffe und Herkunft",
        title: "Springen Sie zum Bereich: Rohstoffe und Herkunft",
        href: { hash: "#anker-umwelt" },
      },
      {
        name: "Technische Innovation",
        title: "Springen Sie zum Bereich: Technische Innovation",
        href: { hash: "#anker-innovation" },
      },
      {
        name: "Zukunft",
        title: "Springen Sie zum Bereich: Zukunft der Produktion",
        href: { hash: "#anker-zukunft" },
      },
    ];
  }
}
